/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Website_PlaceholderInputs */

const en_company_registration_website_placeholder = /** @type {(inputs: Company_Registration_Website_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://...`)
};

const de_company_registration_website_placeholder = /** @type {(inputs: Company_Registration_Website_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://...`)
};

/**
* | output |
* | --- |
* | "https://..." |
*
* @param {Company_Registration_Website_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_website_placeholder = /** @type {((inputs?: Company_Registration_Website_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Website_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_website_placeholder(inputs)
	return en_company_registration_website_placeholder(inputs)
});